

<div class="container">
	<div class="row">
        <div class="col-12">
            <h1>Dispo Report</h1>
			<div class="row">
				<div class="col-4" style="overflow: visible; position:relative">
					<label for="">Date Range</label>
					<!-- ======================================================= -->
					<app-form-range-date
						[(ngModel)]="dateRange_"
						(OnSelected)="dateSelected($event)"
						[position]="'right'"
						[range_type]="'RANGE_PAST'"
						[autoApply]="true"
					></app-form-range-date>
				</div>
				<div class="col-8" align="left">
					<button type="button" class="btn btn-secondary waves-effect waves-light" style="bottom: 0px; position:absolute" (click)="getDispos()">Get Report</button>
				</div>
			</div>
        </div>
    </div>
	<br>
	<div class="row">
		<div class="col-12">
			<div class="card">
				<div class="card-body">

					<ul class="nav nav-pills nav-justified mb-3">
						<li class="nav-item waves-effect waves-light" (click)="onTabClick('all')">
							<a class="nav-link" [ngClass]="{'active-all': selectedTab === 'all'}" >
								All types
							</a>
						</li>
						<li class="nav-item waves-effect waves-light" (click)="onTabClick('black')">
							<a class="nav-link" [ngClass]="{'active-dark': selectedTab === 'black'}" >
								Black Dispos
							</a>
						</li>
						<li class="nav-item waves-effect waves-warning"  (click)="onTabClick('yellow')">
							<a class="nav-link" [ngClass]="{'active-yellow': selectedTab === 'yellow'}">
								Yellow Dispos
							</a>
						</li>
						<li class="nav-item waves-effect waves-danger" (click)="onTabClick('blue')">
							<a class="nav-link" [ngClass]="{'active-blue': selectedTab === 'blue'}">
								Blue Dispos
							</a>
						</li>
						<li class="nav-item waves-effect waves-light" (click)="onTabClick('green')">
							<a class="nav-link" [ngClass]="{'active-green': selectedTab === 'green'}">
								Green Dispos
							</a>
						</li>
					</ul>

					<div class="row">
						<apx-chart
						[series]="chartStructure.series"
						[chart]="chartStructure.chart"
						[xaxis]="chartStructure.xaxis"
						[stroke]="chartStructure.stroke"
						[dataLabels]="chartStructure.dataLabels"
						[legend]="chartStructure.legend"
						[markers]="chartStructure.markers"
						[grid]="chartStructure.grid"
						[yaxis]="chartStructure.yaxis"
						[title]="chartStructure.title"
						[update$]="update$"
						[colors]="chartStructure.colors"
						*ngIf="!loading"
					></apx-chart>
					</div>

					<div class="row" *ngIf="!loading">
						<div class="col-9">
							<label for="">Search</label>
							<input
						class="form-control"
						type="text"
						placeholder="Search"
						(keyup)="updateFilter2($event,'prospect_name,dispo,caller_name,campaign_name,notes')"
						/>
						</div>
						<div class="col-3">
							<label for="">Page Size</label>
							<select class="form-select" [(ngModel)]="recordsPerPage" (change)="onRecordsPerPageChange()">
								<option [value]="10">10</option>
								<option [value]="30">30</option>
								<option [value]="50">50</option>
								<option [value]="100">100</option>
								<option [value]="500">500</option>
							</select>
						</div>
					</div>

						<app-loader *ngIf="loading"></app-loader>
						<ngx-datatable
							#table
							class="material"
							[columnMode]="ColumnMode.force"
							[headerHeight]="50"
							[footerHeight]="50"
							rowHeight="auto"
							[limit]="recordsPerPage"
							[rows]="data"
							[scrollbarH]="true"
							*ngIf="!loading"
							>
							<ngx-datatable-column name="#" [width]="50">
								<ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
									{{rowIndex + 1}}
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Id" prop="id" headerClass="cell-center title-header" cellClass="cell-center" [width]="70">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<span style="font-weight: 600; cursor: pointer" (click)="getDispoDetails(row.id, dispoDetailsModal)">{{row.id}}</span>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Prospect" prop="prospect_name" headerClass="title-header" [width]="170">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<span style="font-weight: 100;">{{row.prospect_name}}</span>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Phone Number" prop="primary_phone" headerClass="cell-center title-header" cellClass="cell-center" [width]="130">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<span style="font-weight: 100;">{{row.primary_phone | phone }}</span>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Dispo type" prop="dispo" headerClass="cell-center title-header" cellClass="cell-center" [width]="80">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<span style="font-weight: 100;" class="badge"
										[ngClass]="getBadgeColor(row.dispo)">
										{{row.dispo}}
									</span>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Who make it" prop="caller_name" headerClass="title-header" [width]="150">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<span style="font-weight: 100;">{{row.caller_name}}</span>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Campaign" prop="campaign_name" headerClass="title-header" [width]="150">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<span style="font-weight: 100;">{{row.campaign_name}}</span>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Creation Date" prop="date" headerClass="cell-center title-header" cellClass="cell-center" [width]="100">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<span style="font-weight: 100;">{{row.date | utcToLocal : 'mediumDate'}}</span>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Notes" prop="notes" headerClass="title-header" [width]="300">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<span style="font-weight: 100;">{{row.notes}}</span>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-footer>
								<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-curPage="curPage">
									<div class="footer-info">
										<div class="d-flex justify-content-between">
											<span>Total Rows: {{rowCount}}</span>
											<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'"
															 [pagerRightArrowIcon]="'datatable-icon-right'"
															 [pagerPreviousIcon]="'datatable-icon-prev'"
															 [pagerNextIcon]="'datatable-icon-skip'"
															 [page]="curPage"
															 [size]="true"
															 [limit]="recordsPerPage"
															 [count]="rowCount"
															 [hidden]="!(rowCount / pageSize > 1)"
															 (change)="table.onFooterPage($event)">
											</datatable-pager>
										</div>
									</div>
								</ng-template>
							</ngx-datatable-footer>
						</ngx-datatable>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal for Dispo Details -->
	<ng-template #dispoDetailsModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Dispo {{selectedDispo.dispo_id}}</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
		</div>
		<div class="modal-body">
			<div class="row">
				<div class="col-12">
					<h3>Prospect details:</h3>
				</div>
			</div>
			<div class="row">
				<div class="col-4">
					<strong>Name:</strong> {{selectedDispo.first_name}} {{selectedDispo.last_name}}
				</div>
				<div class="col-4">
					<strong>Phone:</strong>	{{selectedDispo.primary_phone === '' ? '-' : selectedDispo.primary_phone | phone }}
				</div>
				<div class="col-4">
					<strong>Mobile Phone:</strong> {{selectedDispo.mobile_phone === '' ? '-' : selectedDispo.mobile_phone | phone }}
				</div>
			</div>

			<div class="row">
				<div class="col-4">
					<strong>Primary Email:</strong> {{selectedDispo.primary_email === '' ? '-' : selectedDispo.primary_email }}
				</div>
				<div class="col-4">
					<strong>Alt Email:</strong> {{selectedDispo.alt_email === '' ? '-' : selectedDispo.alt_email }}
				</div>
			</div>

			<div class="row">
				<div class="col-4">
					<strong>Address 1:</strong> {{selectedDispo.address_1 === '' ? '-' : selectedDispo.address_1}}
				</div>
				<div class="col-4">
					<strong>Address 2:</strong> {{selectedDispo.address_2 === '' ? '-' : selectedDispo.address_2}}
				</div>
				<div class="col-4">
					<strong>City:</strong> {{selectedDispo.city}}, {{selectedDispo.state}}
				</div>
			</div>

			<div class="row">
				<div class="col-4">
					<strong>Bussines Code:</strong> {{selectedDispo.bussines_code === '' ? '-' : selectedDispo.bussines_code}}
				</div>
				<div class="col-4">
					<strong>Bussines Code Description:</strong> {{selectedDispo.business_code_description === '' ? '-' : selectedDispo.business_code_description}}
				</div>
				<div class="col-4">
					<strong>EIN:</strong> {{selectedDispo.EIN === '' ? '-' : selectedDispo.EIN}}
				</div>
			</div>



			<div class="row">
				<div class="col-4">
					<strong>Company name:</strong> {{selectedDispo.company_name === '' ? '-' : selectedDispo.company_name}}
				</div>
				<div class="col-4">
					<strong>Plan Assets:</strong> {{selectedDispo.plan_assets === '' ? '-' : selectedDispo.plan_assets}}
				</div>
				<div class="col-4">
					<strong>Employee Size:</strong> {{selectedDispo.employee_size === '' ? '-' : selectedDispo.employee_size }}
				</div>
			</div>

			<div class="row">
				<div class="col-4">
					<strong>Provider 1:</strong> {{selectedDispo.provider_1 === '' ? '-' : selectedDispo.provider_1}}
				</div>
				<div class="col-4">
					<strong>Renewal Month 1:</strong> {{selectedDispo.renewal_month_1 === '' ? '-' : selectedDispo.renewal_month_1}} / {{selectedDispo.renewal_year_1 === '' ? '-' : selectedDispo.renewal_year_1 }}
				</div>
			</div>

			<div class="row">
				<div class="col-4">
					<strong>Provider 2:</strong> {{selectedDispo.provider_2 === '' ? '-' : selectedDispo.provider_2}}
				</div>
				<div class="col-4">
					<strong>Renewal Month 2:</strong> {{selectedDispo.renewal_month_2 === '' ? '-' : selectedDispo.renewal_month_2}} / {{selectedDispo.renewal_year_2 === '' ? '-' : selectedDispo.renewal_year_2 }}
				</div>
			</div>

			<div class="row">
				<div class="col-6">
					<strong>Form 5500:</strong> {{selectedDispo.form_5500 === '' ? '-' : selectedDispo.form_5500}}
				</div>
				<div class="col-6">
					<strong>Aditional Info:</strong> {{selectedDispo.additional_info === '' ? '-' : selectedDispo.additional_info}}
				</div>
			</div>
			<hr>
			<div class="row">
				<div class="col-12">
					<h3>Dispo Details:</h3>
				</div>
			</div>

			<div class="row">
				<div class="col-2">
					<strong>Dispo type:</strong>
					<span style="font-weight: 100; font-size: 15px; margin-left: 5px" class="badge"
						[ngClass]="getBadgeColor(selectedDispo.dispo)">
						{{selectedDispo.dispo}}
					</span>
				</div>
				<div class="col-3">
					<strong>Created:</strong> {{selectedDispo.date === '' ? '-' : selectedDispo.date | utcToLocal : 'medium'}}
				</div>
				<div class="col-3">
					<strong>Created by:</strong> {{selectedDispo.user_name === '' ? '-' : selectedDispo.user_name }}
				</div>
				<div class="col-4">
					<strong>Campaign:</strong> {{selectedDispo.campaign_name === '' ? '-' : selectedDispo.campaign_name }}
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="alert alert-success" style="height: 100px;">
						<strong>Notes:</strong> {{selectedDispo.notes === '' ? '-' : selectedDispo.notes}}
					</div>
				</div>
			</div>

		</div>
	</ng-template>
</div>
